import '../../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.symbol.constructor.js';
import '../../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.symbol.for.js';
import '../../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.symbol.key-for.js';
import '../../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.json.stringify.js';
import '../../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.get-own-property-symbols.js';
import '../../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.symbol.description.js';
import '../../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.function.name.js';
import React from 'react';
import { TiForm } from '../../index.js';
import DatePickerWrap from './DatePickerWrap/index.js';

var DatePicker = function DatePicker(props) {
  var name = props.name,
    label = props.label,
    rules = props.rules,
    border = props.border,
    description = props.description,
    subscribe = props.subscribe,
    _a = props.fieldProps,
    fieldProps = _a === void 0 ? {} : _a;
  return /*#__PURE__*/React.createElement(TiForm.Item, {
    name: name,
    label: label,
    rules: rules,
    direction: "horizontal",
    description: description,
    border: border,
    subscribe: subscribe
  }, /*#__PURE__*/React.createElement(DatePickerWrap, fieldProps));
};

export { DatePicker as default };
